import { useEffect, useState } from 'react'
import { api } from './client'

export interface User {
  id: string
  name: string
  email: string
  role: 'analyst' | 'admin'
}

let cached: User | null | undefined
const listeners = new Set<() => void>()

function notify() {
  listeners.forEach((l) => l())
}

export function useSession() {
  const [user, setUser] = useState<User | null | undefined>(cached)

  useEffect(() => {
    const l = () => setUser(cached)
    listeners.add(l)
    if (cached === undefined) {
      api
        .me()
        .then((u) => {
          cached = u
          notify()
        })
        .catch(() => {
          cached = null
          notify()
        })
    }
    return () => {
      listeners.delete(l)
    }
  }, [])

  return {
    user: user ?? null,
    loading: user === undefined,
    async loginWithCode(email: string, code: string, token = '') {
      cached = await api.verifyCode(email, code, token)
      notify()
    },
    async login(email: string, password: string, code = '') {
      cached = await api.login(email, password, code)
      notify()
    },
    async logout() {
      await api.logout()
      cached = null
      notify()
    },
  }
}
